export default __webpack_public_path__ + "static/7 Ways To Choose The Perfect Mattress-5a3fd2e3aafd43d34423f5fa22122ed7.jpg";